import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  toggleReshapeSetting,
  ReshapeToggleRequest,
} from '../../../../apis/userDetailedSettings'
import { queryKeys } from '../../../../shared'

/**
 * Reshape設定トグル Mutation hook
 */
export const useToggleReshapeSettingMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (request: ReshapeToggleRequest) =>
      toggleReshapeSetting(request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.ocrSettings.reshape(),
      })
    },
  })
}
